export default {
	"name": "authorized.by",
	"stage": "integration",
	"mandanten": ["55"],
	"pagetypes": "produkt",
	"requiresConsent": false,
	"serviceSettings": {
		"scriptSrc": "https://app.authorizedpartner.com/badge-integrator/entry/main.js"
	}
}
